<div class="estimated-total-card"   [class.expanded-fee]="showFeeDetails"
>
  <div class="estimated-header"
  [class.expanded-header]="showFeeDetails"
  >
    <div class="estimated-info">
      <wm-common-text
        [data]="{ text: 'Estimated Total:' }"
        class="estimated-label"
      ></wm-common-text>

      <wm-common-text
        [data]="{ text:(totalFees | currency) }"
        class="estimated-amount"
      ></wm-common-text>
    </div>

    <wm-common-text
      [data]="{ text: showFeeDetails ? 'Close' : 'View Details' }"
      class="estimated-link"
      (click)="toggleDetails()"
    ></wm-common-text>
  </div>

  <div class="estimated-details" *ngIf="showFeeDetails">
    <ng-container *ngIf="displayFees?.length > 0; else noFees">
      <div class="fee-row" *ngFor="let fee of displayFees">
        <wm-common-text
        [data]="{ text: fee.label + ':' }"
        class="estimated-label"
        ></wm-common-text>

        <wm-common-text
        [data]="{ text:(fee.value | currency) }"
        class="estimated-label fee-amount"
        ></wm-common-text>
      </div>
    </ng-container>
      <ng-template #noFees>
    <div class="no-fee-message">
      <wm-common-text
        [data]="{ text: 'Fees not yet Determined.' }"
        class="no-fee-text"
      ></wm-common-text>
    </div>
  </ng-template>
    
  </div>
</div>